/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { Form, Grid, Dropdown } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { formatDate } from 'react-day-picker/moment';
import CurrDealers from './CoopDealersList';
import './ModalEmail.css';

// added for test
class ModalCoopSubmission extends Component {
  state = {
    templates: [
      { key: 0, value: 'ShareLinkTemplate', text: 'Monthly Social Creative' },
      { key: 1, value: 'LeaseSpecialsTemplate2', text: 'Lease Specials' },
      { key: 2, value: 'SingleAdTemplate', text: 'Single Ad' },
      { key: 3, value: 'CampaignTemplate', text: 'Campaign' }
    ],
    selectedTemplate: 'ShareLinkTemplate',
    message: '',
    successMessage: '',
    showPreview: false,
    emailSent: false,
    sendingEmail: false,
    OEM: '',
    OEMArr: [{ key: 'Honda', text: 'Honda', value: 'Honda' }],
    dealer: '',
    dealerOptions: [],
    start: '',
    end: '',
    CCemails: ''
  };

  componentDidMount() {
    this.setEmailTemplate();
  }

  setDealerOptions() {
    // dealer list is handled like this for now (will eventually make a service to get the dealers in another way)
    const { OEM } = this.state;
    if (OEM === 'Honda') {
      const dealerList = CurrDealers[5].dealers; // update this value
      const dealerOptions = dealerList.map(function(currDealer) {
        const keyVal = currDealer.dealer.split(' ')[0];
        return {
          key: keyVal,
          text: currDealer.dealer,
          value: keyVal
        };
      });
      this.setState({ dealerOptions });
    }
  }

  setDealerEmail() {
    const { user } = this.props;
    const { dealer } = this.state;
    if (dealer && dealer !== '') {
      const correctDealer = CurrDealers[5].dealers.find((dealerObj) => {
        return dealerObj.dealer.includes(dealer);
      });
      this.setState({
        CCemails: `${correctDealer.email},${user.email}`
      });
    }
    return 'dealer not found';
  }

  clearCCemails() {
    this.setState({
      CCemails: ''
    });
  }

  handleOEMChange = (e, data) => {
    const key = data.options.find((o) => o.value === data.value).value;
    this.setState(
      {
        OEM: key
      },
      () => {
        this.setDealerOptions();
      }
    );
  };

  handleDealerChange = (e, data) => {
    const key = data.options.find((o) => o.value === data.value).value;
    this.setState(
      {
        dealer: key
      },
      () => {
        this.setDealerEmail();
      }
    );
  };

  // do a case for if dealer is not in the dropdown
  handleDealerChangeBackup = ({ target: { value } }) => {
    this.setState({
      dealer: value
    });
  };

  handleStartChange(day) {
    let start = this.state.start;
    const date = day;
    const formattedDate = `0${date.getDate()}`.slice(-2);
    const formattedMonth = `0${date.getMonth() + 1}`.slice(-2);
    const formattedYear = date
      .getFullYear()
      .toString()
      .substr(2, 2);

    start = `${formattedMonth}/${formattedDate}/${formattedYear}`;
    this.setState({
      start
    });
  }

  handleEndChange(dayEnd) {
    let end = this.state.end;
    const date = dayEnd;
    const formattedDate = `0${date.getDate()}`.slice(-2);
    const formattedMonth = `0${date.getMonth() + 1}`.slice(-2);
    const formattedYear = date
      .getFullYear()
      .toString()
      .substr(2, 2);

    end = `${formattedMonth}/${formattedDate}/${formattedYear}`;
    this.setState({
      end
    });
  }

  handleCCEmailsChange = ({ target: { value } }) => {
    this.setState({
      CCemails: value
    });
  };

  sendCOOP = () => {
    const { sendPDF, user } = this.props;
    const { OEM, dealer, start, end, CCemails } = this.state;
    if (OEM === '' || dealer === '' || start === '' || end === '') {
      toast('Please Fill Out All Fields Before Submitting', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 3000,
        type: toast.TYPE.WARNING,
        hideProgressBar: true
      });
    } else {
      // old way: sendPDF(user.email, OEM, dealer, start, end, CCemails);
      sendPDF({
        recipient: user.email,
        OEM,
        dealer,
        start,
        end,
        CCemails
      });
      toast(
        'The Coop Submit request was sent. Please check your email in a few minutes',
        {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 5000,
          type: toast.TYPE.SUCCESS,
          hideProgressBar: true
        }
      );
    }
  };

  setEmailTemplate = () => {
    const currentTemplateSelection = this.props.coopTypeSelection;
    const foundTemplate = this.state.templates.find((template) => {
      return template.text === currentTemplateSelection;
    });
    if (foundTemplate) {
      this.setState({ selectedTemplate: foundTemplate.value });
    }
  };

  render() {
    const { closeCoopModal } = this.props;
    const { dealer, start, end, OEMArr, dealerOptions, CCemails } = this.state;
    const { emailSent } = this.state.emailSent;

    return (
      <div>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <h4 className="preview-title">Preview Honda COOP Portal</h4>
              <h5>
                Please fill out the information below then submit the form
              </h5>
              <hr />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <h5>OEM</h5>
              <Dropdown
                search
                searchInput={{ type: 'string' }}
                selection
                options={OEMArr}
                placeholder="Please Select OEM"
                onChange={this.handleOEMChange}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <h5>Dealer Code</h5>
              <Dropdown
                search
                searchInput={{ type: 'string' }}
                selection
                options={dealerOptions}
                placeholder="Select a Dealer"
                onChange={this.handleDealerChange}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <h5>Dealer Code (If not found above)</h5>
              <div className="ui focus input">
                <input
                  type="text"
                  value={dealer}
                  placeholder="ex. 207164"
                  onChange={this.handleDealerChangeBackup}
                />
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <h5>Start Date</h5>
              <DayPickerInput
                formatDate={formatDate}
                placeholder="Start"
                onDayChange={(day) => this.handleStartChange(day)}
                value={start}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <h5>End Date</h5>
              <DayPickerInput
                formatDate={formatDate}
                placeholder="End"
                onDayChange={(day) => this.handleEndChange(day)}
                value={end}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <h5>
                CC Email (make sure that the dealer email is included with your
                own)
              </h5>
              <h5>
                Separate emails with a comma ex. (abc@test.com,cde@test.com)
              </h5>
              <div className="ui focus input">
                <input
                  type="text"
                  value={CCemails}
                  placeholder="ex. your email"
                  onChange={this.handleCCEmailsChange}
                />
              </div>
            </Grid.Column>
          </Grid.Row>

          <br />

          <Grid.Row>
            <Grid.Column>
              <hr />
              <div className="model-buttons-container">
                <Form.Button
                  size="small"
                  floated="left"
                  color="grey"
                  onClick={closeCoopModal}
                >
                  Close
                </Form.Button>
                {!emailSent ? (
                  <Form.Button
                    size="small"
                    floated="left"
                    color="blue"
                    onClick={this.sendCOOP}
                  >
                    Send
                  </Form.Button>
                ) : (
                  <Form.Button
                    size="small"
                    floated="left"
                    color="grey"
                    onClick={closeCoopModal}
                  >
                    Close
                  </Form.Button>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <p>
                <b>
                  {`NOTE: You MUST have the dealer's email CC'd or else Honda will
                  NOT review the submission (separate the emails with a comma)`}
                </b>
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default ModalCoopSubmission;



// WEBPACK FOOTER //
// ./src/screens/Presentation/ModalCoopHondaSubmission.js